import locations from './locations';
import buildings from './buildings';
import building_floors from './building_floors';
import location_details from './location_details';
import location_building_floors from './location_building_floors';
import directions from './directions';
import point_of_interest_types from './point_of_interest_types';
import point_of_interests from './point_of_interests';
import geojson from './geojson';
import asset from './aseet';
import panorama_nodes from './panorama_nodes';
import panorama_edges from './panorama_edges';

const API = {
	buildings,
	building_floors,
	locations,
	location_details,
	location_building_floors,
	geojson,
	directions,
	asset,
	point_of_interest_types,
	point_of_interests,
	panorama_nodes,
	panorama_edges
};

export default API;